// extracted by mini-css-extract-plugin
export default {"article_background":"section_article_background__nwBNt","preformat_text":"section_preformat_text__xge7E"};